import React, { useState } from "react";
import { Card, CardBody, Col, Container, Row, Nav, NavItem, NavLink, Button, Input } from "reactstrap";
import classnames from "classnames";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

const Sertifikalarim = () => {
  document.title = "Sertifikalarım | LojGo";

  const [activeTab, setActiveTab] = useState("1");

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="LojGo" breadcrumbItem="Sertifikalarım" />
          
          <div className="d-flex justify-content-between align-items-center mb-4">
              <h2 className="mb-0">Sertifikalarım</h2>
              <Button color="light" size="sm" className="text-primary border-primary bg-transparent fw-medium">
                  <i className="mdi mdi-help-circle-outline me-1"></i> Sertifikalar hakkında daha fazla bilgi edinin
              </Button>
          </div>

          <Row>
            <Col xs={12}>
              <Card className="shadow-none bg-transparent mb-0">
                <CardBody className="pt-0 pb-0 border-bottom">
                  <Nav tabs className="nav-tabs-custom border-bottom-0">
                    <NavItem>
                      <NavLink 
                        className={classnames({ active: activeTab === "1" }, "fw-medium")} 
                        style={{cursor: 'default'}}
                      >
                        Sertifikalar
                      </NavLink>
                    </NavItem>
                  </Nav>
                </CardBody>
              </Card>

              {/* İçerik Alanı - Üzerinde Overlay (Karanlık Katman) Bulunan Kısım */}
              <div className="position-relative mt-2" style={{ minHeight: '500px' }}>
                
                {/* 1. ARKA PLAN: Bulanıklaştırılmış (Blurred) Sahte İçerik */}
                <div 
                    className="bg-white p-5 rounded border w-100 h-100 position-absolute" 
                    style={{ filter: 'blur(5px)', userSelect: 'none', pointerEvents: 'none' }}
                >
                    <Row className="mb-5">
                        <Col md={3} className="fw-bold">Müşteri sertifikası alındı</Col>
                        <Col md={9}>
                            <div className="bg-light p-3 rounded text-muted mb-3">
                                Şu anda herhangi bir müşteri sertifikasını doğrulamadınız...
                            </div>
                            <div className="d-flex gap-2 align-items-center">
                                <Input type="select" disabled className="w-50">
                                    <option>Bir müşteri süreci seçin...</option>
                                </Input>
                                <Button color="dark" disabled>Erişim</Button>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={3} className="fw-bold">Elde edilen tamamlayıcı hizmetlerin sertifikasyonu</Col>
                        <Col md={9}>
                            <div className="bg-light p-3 rounded text-muted mb-3">
                                Şu anda herhangi bir sertifikasını doğrulamadınız...
                            </div>
                            <div className="d-flex gap-2 align-items-center">
                                <Input type="select" disabled className="w-50">
                                    <option>Tamamlayıcı bir hizmet seçin...</option>
                                </Input>
                                <Button color="dark" disabled>Erişim</Button>
                            </div>
                        </Col>
                    </Row>
                </div>

                {/* 2. ÖN PLAN: Karanlık Katman ve QR Kod (Overlay) */}
                <div 
                    className="position-absolute top-0 start-0 w-100 h-100 bg-dark bg-opacity-75 rounded d-flex flex-column justify-content-center align-items-center text-center p-4"
                    style={{ zIndex: 10 }}
                >
                    <i className="mdi mdi-lock text-white display-4 mb-2"></i>
                    <h5 className="text-white fw-bold mb-2">Sertifikalarınıza erişin</h5>
                    <p className="text-white mb-4">Tüm sertifikalarınıza erişmek için lütfen mobil uygulamaya bakın.</p>
                    
                    <div className="bg-white p-2 rounded shadow mb-2 d-inline-block">
                        {/* Gerçek bir QR kod resmi de koyabilirsiniz, şimdilik ikonik büyük bir QR tasarımı kullanıyoruz */}
                        <i className="mdi mdi-qrcode-scan text-dark" style={{ fontSize: '100px', lineHeight: '100px' }}></i>
                    </div>
                    
                    <div className="text-white fw-medium mt-1">
                        ⬆️ Bu QR Kodunu tara 📸
                    </div>
                </div>

              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Sertifikalarim;